export default class ComponentsPage {
	constructor() {
	}
}